import React from 'react'
import Row, { Slot } from './row'
import Button from './button'
import styles from '../component-styles/connect-button.module.scss'
import AnalyticsImage from '../assets/analytics-button.png'
import Stars from '../assets/star-cluster-yellow.svg'
import AAImage from '../assets/aa-logo-button.png'
import Tag from './tag'
import { connectToGoogle } from '../api-client/settings-client'
import { calendarBookingLink } from '../core/variables'

export default function ConnectButton({
  adobe,
}: {
  adobe?: boolean
}): React.ReactElement {
  const onClick = () => {
    connectToGoogle({ returnTo: '/connect-website' })
  }
  const onClickAdobe = () => {
    window.location.assign(calendarBookingLink)
  }
  if (adobe) {
    return (
      <div
        className={styles.card}
        onClick={onClickAdobe}
        onKeyDown={onClickAdobe}
        role="button"
        tabIndex={-1}
      >
        <Row>
          <Slot align="center" width={140}>
            <Button type="bigGrey" className={styles.analyticsButton}>
              <img
                src={AAImage}
                alt="connect to Adobe Analytics"
                style={{ display: 'block' }}
              />
            </Button>
          </Slot>
          <Slot align="flex-start">
            <Row style={{ padding: '12px 15px' }}>
              <Slot>
                <div>
                  <Tag text="REQUEST INTEGRATION" icon={Stars} />
                </div>
                <h3 className={styles.title}>Connect Adobe Analytics</h3>
              </Slot>
            </Row>
          </Slot>
        </Row>
      </div>
    )
  }

  return (
    <div
      className={styles.card}
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={-1}
    >
      <Row>
        <Slot align="center" width={140}>
          <Button type="bigGrey" className={styles.analyticsButton}>
            <img
              src={AnalyticsImage}
              alt="connect to Google Analytics"
              style={{ display: 'block' }}
            />
          </Button>
        </Slot>
        <Slot align="flex-start">
          <Row style={{ padding: '12px 15px' }}>
            <Slot>
              <div>
                <Tag />
              </div>
              <h3 className={styles.title}>Connect Google Analytics</h3>
            </Slot>
          </Row>
        </Slot>
      </Row>
    </div>
  )
}
